
import React from 'react';
import CardItem from '../Cards/CardItem';
import '../Cards/Cards.css';
import artefact from '../../images/artefact_logo.png';
import costume from '../../images/costumes_logo.png';
import folklore from '../../images/folklore.png';
import tc from '../../images/tc.png';
import melayu from '../../images/melayu_description.png';

function Melayu() {
    return (
      <div className='cards'>
        <img className='culture__description' src= {melayu} alt='description'/>
        <h1>EXPLORE </h1>
        <div className='cards__container'>
          <div className='cards__wrapper'>
            <ul className='cards__items'>
              <CardItem
                src= {artefact}
                text="Cultural artefacts allow us to gain information about the culture of its creators and users. They have a significance because they offer an insight into the technological prcoesses, economic development, social structure and other cultural attributes. "
                label='ARTEFACTS'
                path='../malay-artefacts'
              />
              <CardItem
                src= {costume}
                text="Traditional dresses are defined as the ensemble of garments, jewellery adn accessories rooted in the past and worn by an identifiable group of people. "
                label='TRADITIONAL COSTUMES'
                path='../malay-costumes'
              />
            </ul>
            <ul className='cards__items'>
              <CardItem
                src={folklore}
                text='Folklore not only encompasses of traditional beliefs, customs, and stories passed through generations of people but also include oral traditions, customary lore, and materialcultrue ranging from traditional building styles to handmade trinkets common to the cultural group.'
                label='FOLKLORES'
                path='../malay-folklores'
              />
              <CardItem
                src= {tc}
                text='Most ethnic groups in Sarawak still observe many of their traditional rituals and beliefs. Sarawak celebrates colourful festivals such as the Gawai Dayak (harvest festival), Gawai Kenyalang (hornbill, or the god of war festival), penuaian padi and Gawai Antu (festival of the dead).'
                label='TRADITIONAL CEREMONIES'
                path='../malay-ceremonies'
              />
              
            </ul>
          </div>
        </div>
      </div>
    );
  }
  
  export default Melayu;